module.exports = __webpack_public_path__ + "img/2.dc12c690.png";